import { ReactElement } from "react"
import { faCloudDownload } from "@fortawesome/free-solid-svg-icons"
import useCommon from "hooks/useCommon"
import { useDownloadOriginSurveyHHMutation, useDownloadSurveyHouseholdFileMutation } from "services/household/survey"
import RenderRow from "components/Shared/Property/RenderRow"
import { SurveyById } from "interfaces/dataInterfaces"
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query"

type Props = {
  survey?: SurveyById
}

const SurveyViewData = ({ survey }: Props): ReactElement => {
  const { showSnackBar } = useCommon()
  const [downloadOriginSurvey, { isLoading: loadingSurvey }] = useDownloadOriginSurveyHHMutation()
  const [downloadSurveyHouseholdFile] = useDownloadSurveyHouseholdFileMutation()

  const handleDownloadCSV = async (surveyId: number, fileName: string): Promise<void> => {
    try {
      await downloadOriginSurvey({ surveyId, file: fileName }).unwrap()
    } catch (error) {
      showSnackBar("An error occurred while downloading a required file", "error")
    }
  }
  const handleDownloadJSON = async (surveyId: number, dataType: "FullData" | "BaseData"): Promise<void> => {
    try {
      await downloadSurveyHouseholdFile({ surveyId, dataType, format: "json" }).unwrap()
    } catch (err) {
      const error = err as FetchBaseQueryError
      showSnackBar(
        (error?.data as { message: string })?.message ?? "An error occurred while downloading a required file",
        "error",
      )
    }
  }

  return (
    <div className="p-3">
      <table>
        <RenderRow
          label="Data CSV"
          value={survey?.surveyOriginalFilename}
          icon={faCloudDownload}
          action={() => {
            survey && handleDownloadCSV(survey.surveyId, survey.surveyOriginalFilename)
          }}
          isLoading={loadingSurvey}
        />
        <RenderRow
          label="Full data JSON"
          value="View"
          icon={faCloudDownload}
          action={() => {
            survey && handleDownloadJSON(survey.surveyId, "FullData")
          }}
        />
        <RenderRow
          label="Base data JSON"
          value="View"
          icon={faCloudDownload}
          action={() => {
            survey && handleDownloadJSON(survey.surveyId, "BaseData")
          }}
        />
        <RenderRow label="Processed data CSV" value="" />
        <RenderRow label="Processed data JSON" value="" />
      </table>
    </div>
  )
}

export default SurveyViewData
